import { paymentMethodTypeEnum } from '../../../../../../../../api/vouchers/helpers';
import type { PreReceiptState } from '../PreReceiptState';

export function getAmountByPaymentMethodType<
    T extends Pick<PreReceiptState, 'paymentMethodObject' | 'paymentMethodType' | 'amount'>
>({ paymentMethodType, paymentMethodObject, amount }: T) {
    switch (paymentMethodType) {
        case paymentMethodTypeEnum.CHECK: {
            return paymentMethodObject.checks?.reduce(
                (acc: number, next: { amount?: number }) => acc + (next?.amount || 0),
                0
            );
        }
        case paymentMethodTypeEnum.VOUCHER: {
            return paymentMethodObject.vouchers?.reduce(
                (acc: number, next: { amount?: number }) => acc + (next?.amount || 0),
                0
            );
        }
        case paymentMethodTypeEnum.CREDIT_CARD:
        case paymentMethodTypeEnum.CASH:
        case paymentMethodTypeEnum.BANK_TRANSFER:
        default:
            return amount;
    }
}
